import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter, Mutation } from 'vuex-class';
import { USER_DETAILS } from '@/types/authentication.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { UserDetails } from '@/models/UserDetails.model';
import { MenuAction } from '@/models/MenuAction.model';
import { LOGOUT_WS } from '@/types/authorization.types';
import {
  SET_CHANGE_PASSWORD_ERRORS,
  SET_CHANGE_PASSWORD_LOADING,
  SET_PERFORM_CHANGE_PASSWORD,
  SET_USER_PERFORM_DATA_CLEANSING,
} from '@/types/lobby.types';

@Component({})
export default class HeaderComponent extends Vue {

  @Action(LOGOUT_WS, StoreNamespace.AUTHORIZATION) public logout;

  @Mutation(SET_USER_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public setUserPerformDataCleansing;
  @Mutation(SET_PERFORM_CHANGE_PASSWORD, StoreNamespace.LOBBY) public setPerformChangePassword;
  @Mutation(SET_CHANGE_PASSWORD_ERRORS, StoreNamespace.LOBBY) public setChangePasswordErrors;
  @Mutation(SET_CHANGE_PASSWORD_LOADING, StoreNamespace.LOBBY) public setChangePasswordLoading;

  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;

  public isOpened: boolean = false;
  public headerMenuActions: MenuAction[] = [];

  public created() {
    if (!this.userDetails.loginFromSso) {
      this.headerMenuActions.push({
        name: 'header.user_data_cleansing',
        event: 'onUserDataCleansing',
        faIconName: 'cog',
        faIconType: 'fal',
        withDivider: true,
      });
      this.headerMenuActions.push({
        name: 'header.change_password',
        event: 'onChangePassword',
        faIconName: 'lock-alt',
        faIconType: 'fal',
        withDivider: true,
      });
    }
    this.headerMenuActions.push({
      name: 'header.logout',
      event: 'onLogout',
      faIconName: 'sign-out',
      faIconType: 'fal',
    });

    this.setPerformChangePassword(false);
    this.setUserPerformDataCleansing(false);
    window.addEventListener('scroll', this.handleScrollClasses);
  }

  public onLogout() {
    this.logout();
  }

  public onChangePassword() {
    // this.$router.push({ name: 'change-password' });
    this.setChangePasswordErrors([]);
    this.setChangePasswordLoading(false);
    this.setPerformChangePassword(true);
  }

  public onUserDataCleansing() {
    // this.$router.push({ name: 'UserDataCleansing' });
    this.setUserPerformDataCleansing(true);
  }

  public onChangeDetails() {
    // this.$root.$emit('onChangeDetails');
  }

  public toggleMenu() {
    this.isOpened = !this.isOpened;
    if (!this.isOpened) {
      document.body.classList.remove('sidebar-hidden');
    } else {
      document.body.classList.add('sidebar-hidden');
    }
  }

  public handleScrollClasses(event: any) {
    const bodyEl: any = document.querySelector('body');
    if (window.scrollY > 30 && !bodyEl.className.includes('scrolled')) {
      bodyEl.classList.add('scrolled');
    } else if (window.scrollY < 30) {
      bodyEl.classList.remove('scrolled');
    }
  }


}

